var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-row',{staticClass:"mt-8 mb-5",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"11","md":"8","xl":"7"}},[_c('div',{staticClass:"title-text"},[_vm._v(" Jobs ")]),_c('v-divider',{staticClass:"neon-divider",staticStyle:{"border-width":"1.5px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }